import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './lager-lagerplatz.list-view.html',
    styleUrls: ['./lager-lagerplatz.list-view.scss']
})
export class LagerLagerplatzListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
